import { apiSlice } from '@services/apiSlice';
import { SafetyDatasheet as endpoints } from '@services/endpoints';
import { SafetyDataSheet } from './SafetyDatasheet.types';

interface SafetyDataSheetResponse {
  LanguageLabel: string;
  SafetyDataSheetItems: SafetyDataSheet[];
  SizeLabel: string;
  VersionLabel: string;
}

const safetyDatasheetApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    fetchSafetyDatasheet: build.query<SafetyDataSheetResponse, void>({
      query: () => ({
        url: endpoints.fetchSafetyDatasheet,
        params: { lang: window.lang },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useFetchSafetyDatasheetQuery } = safetyDatasheetApi;
